var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93811 8.00622V0.918061C3.93811 0.638707 4.13739 0.411972 4.38291 0.411972H0.825628C0.579888 0.411972 0.380859 0.638743 0.380859 0.918061V8.00622C0.380859 8.28565 0.579888 8.51242 0.825628 8.51249H4.12486L3.99682 8.25734C3.95769 8.18062 3.93811 8.09442 3.93811 8.00622Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3409 5.26913L13.9147 1.61467C13.6309 0.884797 12.9925 0.411972 12.2897 0.411972H5.59748H5.15281C4.90728 0.411972 4.70801 0.638743 4.70801 0.918061V8.00622C4.70801 8.09442 4.72759 8.18062 4.76672 8.25734L4.89476 8.51249L6.4868 11.6849V14.0816C6.4868 14.3612 6.68608 14.5881 6.93123 14.5881H8.26554C9.24645 14.5881 10.044 13.6796 10.044 12.563V9.52516H13.6016C14.5826 9.52516 15.3803 8.61671 15.3803 7.49996V5.47476C15.3803 5.40402 15.367 5.33405 15.3409 5.26913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.25c04e0731e6d326d81642b099210e68.svg";
export { ForwardRef as ReactComponent };